const STORE_ICON_GOOGLE = "https://cdn.shopify.com/s/files/1/0796/1959/files/google.png?v=1721205440";
// PDP module analytics (events sheet). Helper lives in assets/clevertap_custom.js.liquid,
// which is deferred AFTER this file — queue until it exists.
function kStoreTrack(name, props) {
  if (typeof window.kPdpTrack === 'function') window.kPdpTrack(name, props);
  else (window.__kPdpTrackQueue = window.__kPdpTrackQueue || []).push([name, props]);
}
const STORE_ICON_CALL = "https://cdn.shopify.com/s/files/1/0796/1959/files/fluent_call-28-regular_8421deb0-ea92-4d83-b8eb-83dd7c87b04b.png?v=1720074796";
const STORE_ICON_DIRECTION = "https://cdn.shopify.com/s/files/1/0796/1959/files/teenyicons_direction-solid.png?v=1719300137";
let productImage = document.querySelector('.stInventory-overlay');
productImage = productImage?.getAttribute('data-img');
let pdpProductTitle = document.querySelector('.stInventory-overlay');
pdpProductTitle = pdpProductTitle?.getAttribute('data-product');
let selectedSKU = document.querySelector('.stInventory-overlay');
selectedSKU = selectedSKU?.getAttribute('data-sku');
let productFullImage = `https://www.kushals.com/cdn/shop/${productImage}`;
let storeAvailableIcon = document.querySelector('.available-at-store');
let allStoresPopupState = null;

const ALL_STORES_POPUP_ID = 'ct-all-stores-popup';
let __pdpNearStoreRefreshRaf = 0;
let __pdpNearStoreBootstrapTimer = 0;

function normalizeStoreCityName(value) {
  return String(value || '').trim().toLowerCase();
}

function getStoreCityName(store) {
  return store?.cityName || store?.city || store?.state || '';
}

function hasAnyGlobalModalOpen() {
  return Boolean(
    document.querySelector('.stInventory-overlay.show, .appmt-overlay.show')
  );
}

function normalizeSearchText(value) {
  return String(value || '').toLowerCase().trim();
}

function normalizeStoreIdentifier(value) {
  return String(value || '').trim().toLowerCase();
}

function getLocationStoreData() {
  try {
    const raw = localStorage.getItem('location_store') || '{}';
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return {};
    // store: 0 is what header.liquid writes for a no-store pincode. Older code kept the previous pincode's
    // storeList next to it, and that stale entry survives in localStorage across sessions/themes — so a
    // no-store location must read as an empty list no matter what the stored array says (2026-10-23, 571201).
    if ((parsed.store === 0 || parsed.store === '0') && Array.isArray(parsed.storeList) && parsed.storeList.length) {
      return Object.assign({}, parsed, { storeList: [] });
    }
    return parsed;
  } catch (e) {
    return {};
  }
}

function getPopupStoreDistanceLabel(store) {
  // Same source order as the inline nearby list (pdp-delivery-stores.js):
  // live geolocation first, then whatever location_store carries. A
  // city-picked location has no lat/lon, so without the live fix the
  // popup always fell back to "Get Direction".
  const loc = window.__kushalsLiveCustomerLocation || getLocationStoreData();
  const uLat = parseFloat(loc.latitude || loc.lat);
  const uLon = parseFloat(loc.longitude || loc.lan || loc.lng);
  const sLat = parseFloat(store.latitude);
  const sLon = parseFloat(store.longitude);
  if ([uLat, uLon, sLat, sLon].some(isNaN)) return '';
  const rad = Math.PI / 180;
  const dLat = (sLat - uLat) * rad;
  const dLon = (sLon - uLon) * rad;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(uLat * rad) * Math.cos(sLat * rad) * Math.sin(dLon / 2) ** 2;
  const km = 2 * 6371 * Math.asin(Math.sqrt(a));
  // Figma always reads "x km away" (2026-10-16); the 0.1 floor avoids "0.0 km away" when standing in the store.
  return `${Math.max(0.1, km).toFixed(1)} km away`;
}

function parseNearStoreCodes(raw) {
  if (Array.isArray(raw)) {
    return raw
      .map((item) => String(item || '').trim().toUpperCase())
      .filter(Boolean);
  }
  const text = String(raw || '').trim();
  if (!text) return [];
  if (text[0] === '[' && text[text.length - 1] === ']') {
    try {
      const parsed = JSON.parse(text);
      if (Array.isArray(parsed)) {
        return parsed
          .map((item) => String(item || '').trim().toUpperCase())
          .filter(Boolean);
      }
    } catch (e) {}
  }
  return text
    .split(',')
    .map((item) => String(item || '').trim().toUpperCase())
    .filter(Boolean);
}

function getVariantNearStoresMap() {
  const overlay = document.querySelector('.stInventory-overlay');
  if (!overlay) return {};
  const raw = String(overlay.getAttribute('data-variant-near-stores') || '').trim();
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (e) {
    return {};
  }
}

function getSelectedVariantId() {
  const selectedFromForm = $("form [name='id']").val();
  if (selectedFromForm != null && String(selectedFromForm).trim() !== '') {
    return String(selectedFromForm).trim();
  }
  const selectedFromProductForm = $(".product-form [name='id']").val();
  if (selectedFromProductForm != null && String(selectedFromProductForm).trim() !== '') {
    return String(selectedFromProductForm).trim();
  }
  const selectedFromOption = $("form [name='id'] option:selected").val();
  if (selectedFromOption != null && String(selectedFromOption).trim() !== '') {
    return String(selectedFromOption).trim();
  }
  return '';
}

function refreshSelectedSkuFromDom() {
  const nextSku =
    $("form [name='id'] option:selected").data("sku") ||
    $(".product-form [name='id'] option:selected").data("sku") ||
    '';
  selectedSKU = String(nextSku || '').trim();
}

function getCurrentVariantNearStoreState() {
  const nearStoreMap = getVariantNearStoresMap();
  const variantId = getSelectedVariantId();
  const variantCodes = parseNearStoreCodes(nearStoreMap[variantId]);
  const normalizedVariantCodes = new Set(variantCodes.map((code) => normalizeStoreIdentifier(code)));

  if (normalizedVariantCodes.size > 0) {
    return {
      nearStoreCodeSet: normalizedVariantCodes,
      hasRestriction: true
    };
  }

  return {
    nearStoreCodeSet: new Set(),
    hasRestriction: false
  };
}

function syncReservedProductState(storeId, bookingId, selectedSkuValue, reservedProductsList) {
  const normalizedStoreId = Number(storeId);
  const normalizedSku = Number(selectedSkuValue);

  if (!Number.isFinite(normalizedStoreId) || !Number.isFinite(normalizedSku)) return;

  const nextEntry = {
    storeId: normalizedStoreId,
    sku: normalizedSku,
    bookingId: bookingId
  };

  let reservedProducts = Array.isArray(reservedProductsList) ? reservedProductsList.slice() : [];
  if (!reservedProducts.length) {
    reservedProducts = readReservedProducts();
  }

  const existingIndex = reservedProducts.findIndex(
    (item) => Number(item.storeId) === normalizedStoreId && Number(item.sku) === normalizedSku
  );

  if (existingIndex >= 0) {
    reservedProducts[existingIndex] = { ...reservedProducts[existingIndex], ...nextEntry };
  } else {
    reservedProducts.push(nextEntry);
  }

  const serialized = JSON.stringify(reservedProducts);
  try { sessionStorage.setItem("storeDetails", serialized); } catch (e) {}
  try { localStorage.setItem("storeDetails", serialized); } catch (e) {}

  if (allStoresPopupState) {
    allStoresPopupState.reservedProducts = Array.isArray(reservedProducts) ? reservedProducts : [];
    allStoresPopupState.selectedSKU = normalizedSku;
  }

  document
    .querySelectorAll(`.store-more-box[data-store-id="${normalizedStoreId}"] .reserve-product`)
    .forEach((button) => {
      button.textContent = 'View Reservation';
      button.setAttribute('onclick', 'stInventoryReservationOpen(this)');
    });
}

function readReservedProducts() {
  const sources = [];

  try {
    const localValue = localStorage.getItem('storeDetails');
    if (localValue) sources.push(localValue);
  } catch (e) {}

  try {
    const sessionValue = sessionStorage.getItem('storeDetails');
    if (sessionValue) sources.push(sessionValue);
  } catch (e) {}

  for (let i = 0; i < sources.length; i++) {
    try {
      const parsed = JSON.parse(sources[i]);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {}
  }

  return [];
}

function hasReservedProductForStore(reservedProducts, storeId, selectedSkuValue) {
  const normalizedStoreId = Number(storeId);
  const normalizedSku = Number(selectedSkuValue);

  if (!Number.isFinite(normalizedStoreId)) return false;

  return (Array.isArray(reservedProducts) ? reservedProducts : []).some((item) => {
    if (Number(item?.storeId) !== normalizedStoreId) return false;
    if (!Number.isFinite(normalizedSku)) return true;
    return Number(item?.sku) === normalizedSku;
  });
}

// Booked appointment for this store? Mirrors updateStoreButtons() (appointment-modal.js) so freshly rendered cards
// print "View Appointment" straight away — the All Stores popup rebuilds its list on every open (user 2026-10-23).
function hasAppointmentForStore(storeId) {
  const id = String(storeId ?? '');
  if (!id) return false;
  try {
    return (JSON.parse(localStorage.getItem('storeVisitData')) || []).some((b) => b && String(b.storeId) === id);
  } catch (e) { return false; }
}

function getStoreShortCodes(store) {
  const codes = [
    store?.shortCode,
    store?.storeNameCode,
    store?.externalStoreCode
  ];
  return codes
    .map((value) => normalizeStoreIdentifier(String(value || '').trim()))
    .filter(Boolean);
}

function isInventoryAvailableForStore(nearStoreCodeSet, store, hasRestriction) {
  if (!hasRestriction) return true;
  const shortCodes = getStoreShortCodes(store);
  return shortCodes.some((code) => nearStoreCodeSet.has(code));
}

function getLocationStoreShortCodeSet() {
  try {
    const locationData = getLocationStoreData();
    const stores = Array.isArray(locationData?.storeList) ? locationData.storeList : [];
    const codeSet = new Set();
    stores.forEach((store) => {
      getStoreShortCodes(store).forEach((code) => codeSet.add(code));
    });
    return codeSet;
  } catch (e) {
    return new Set();
  }
}

function getEffectiveNearStoreAvailabilityState() {
  const variantState = getCurrentVariantNearStoreState();
  const locationCodes = getLocationStoreShortCodeSet();

  if (!variantState.hasRestriction) {
    return {
      nearStoreCodeSet: locationCodes,
      hasRestriction: locationCodes.size > 0
    };
  }

  if (!locationCodes.size) {
    return variantState;
  }

  const mappedToNearby = new Set();
  variantState.nearStoreCodeSet.forEach((code) => {
    if (locationCodes.has(code)) mappedToNearby.add(code);
  });

  return {
    nearStoreCodeSet: mappedToNearby,
    hasRestriction: true
  };
}

function updatePdpAvailableAtStoreBadge() {
  if (!storeAvailableIcon || window.page !== 'product') return;
  try {
    const locationData = getLocationStoreData();
    const stores = Array.isArray(locationData?.storeList) ? locationData.storeList : [];
    const nearStoreState = getEffectiveNearStoreAvailabilityState();
    const nearStoreCodeSet = nearStoreState.nearStoreCodeSet;
    const hasAvailability =
      stores.some((store) => isInventoryAvailableForStore(nearStoreCodeSet, store, nearStoreState.hasRestriction));

    storeAvailableIcon.style.display = hasAvailability ? 'flex' : 'none';
  } catch (e) {
    storeAvailableIcon.style.display = 'none';
  }
}

function refreshPdpStoreAvailabilityUI() {
  updatePdpAvailableAtStoreBadge();
  // location_store is the source of truth. When the current location has no stores (header.liquid writes
  // storeList: [] for a no-store pincode, 2026-10-23), drop the cached list instead of re-rendering it —
  // this ran one frame after handleStoreData() hid the section and brought the previous pincode's cards back.
  const currentStores = getLocationStoreData().storeList;
  if (!Array.isArray(currentStores) || currentStores.length === 0) {
    allStoresPopupState = null;
    return;
  }
  if (allStoresPopupState && Array.isArray(allStoresPopupState.storeList) && allStoresPopupState.storeList.length > 0) {
    updateStoreHTML(allStoresPopupState.storeList, allStoresPopupState.data || {});
  }
}

function schedulePdpStoreAvailabilityRefresh() {
  if (__pdpNearStoreRefreshRaf) cancelAnimationFrame(__pdpNearStoreRefreshRaf);
  __pdpNearStoreRefreshRaf = requestAnimationFrame(function () {
    __pdpNearStoreRefreshRaf = 0;
    refreshPdpStoreAvailabilityUI();
  });
}

// Backward-compatible hook used by main-product.liquid on variant change.
async function fetchStoreInventory() {
  refreshSelectedSkuFromDom();
  // Keep this as a lightweight compatibility hook.
  // main-product.liquid calls handleStoreData() right after this.
  return Promise.resolve();
}

async function getStoreReviews() {
    const geoOptions = { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 };

    const requestPosition = () => {
        navigator.geolocation.getCurrentPosition(
            showPosition_store,
            showError,
            geoOptions
        );
    };

    if (!navigator.geolocation) {
        KToast.error('Location is not supported on this device.');
        return;
    }

    if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions.query({ name: 'geolocation' }).then((result) => {
            if (result.state === 'denied') {
                KToast.error('Please enable location access to find nearby stores.');
            }
            requestPosition();
        }).catch(requestPosition);
    } else {
        requestPosition();
    }
}


if(storeAvailableIcon) {
  storeAvailableIcon.onclick = function() {
    const inventorySection = document.querySelector('.not-in-quickbuy.product-detail-accordion');
    if (inventorySection) {
      inventorySection.scrollIntoView({ behavior: 'smooth' });
    }
  };
}

// Function to call store API
async function callStoreAPI() {
    const locationData = localStorage.getItem('location_store');
    const rawObj = JSON.parse(locationData);
    // Same no-store normalisation as getLocationStoreData() (store: 0 → empty list), keeps the raw object otherwise.
    const obj = rawObj && typeof rawObj === 'object' ? getLocationStoreData() : rawObj;

    let url;
    if (obj.postal) {
        if (obj.lat && obj.lng) {
            url = `${window.publicApiUrl}/near-by?latitude=${obj.lat}&longitude=${obj.lng}`;
        } else {
            url = `${window.publicApiUrl}/near-by?latitude=${obj.latitude}&longitude=${obj.longitude}`;
        }
    } else {
        url = `${window.publicApiUrl}/near-by?city=${obj.state}`;
    }

    try {
        let data;
        if (obj) {
            data = obj;
        } else {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            data = await response.json();
        }

        const waitForElements = () => {
            const appmtImage = document.querySelector('.appmt-image');

            if (appmtImage) {
                if (data?.store !== 0) {
                    appmtImage?.classList.remove('no-store-display');
                } else {
                    appmtImage?.classList.add('no-store-display');
                }
                observer.disconnect();
            }
        };

        // Set up a MutationObserver to watch for DOM changes
        const observer = new MutationObserver(() => {
            waitForElements();
        });

        // Start observing the body for child node changes
        observer.observe(document.body, { childList: true, subtree: true });
        return data;
    } catch (error) {
        throw new Error('Error fetching store data: ' + error.message);
    }
}

// Function to handle errors
function showError(error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            console.error("User denied the request for Geolocation.");
             KToast.error('Location access needed to find nearby stores.');
            break;
        case error.POSITION_UNAVAILABLE:
            console.error("Location information is unavailable.");
             KToast.error('Location information unavailable. Please try again.');
            break;
        case error.TIMEOUT:
            console.error("The request to get user location timed out.");
             KToast.error('Location request timed out. Please try again.');
            break;
        case error.UNKNOWN_ERROR:
            console.error("An unknown error occurred.");
             KToast.error('Unable to detect location.');
            break;
    }
}

// Function to show position
function showPosition_store(position) {
    const { latitude, longitude } = position.coords;
    // Pass the location to your function to handle data
    handleStoreData(latitude, longitude);
}

// Function to handle store data
async function handleStoreData(latitude, longitude) {
  try {
    const data = await callStoreAPI(latitude, longitude);
    if (data.storeList && data.storeList.length > 0) {
            updateStoreHTML(data.storeList, data);
        } else {
            // Handle the case when no store is found
            allStoresPopupState = null;   // stale list must not be re-rendered by refreshPdpStoreAvailabilityUI()
            const moreStoreElement = document.querySelectorAll(".ct_more_store");
            const appmtImage = document.querySelector('.appmt-image');

            moreStoreElement?.forEach((ele) => {
                ele.style.display = "none";
            });

            if (appmtImage) {
                appmtImage.style.display = 'none';
            }
        }
    } catch (error) {
        console.error("Error fetching store data:", error);
    }
}

function hasRenderedPdpNearStoreCards() {
  return !!document.querySelector('.ct_more_store.ct_more_store_product .store-more-box');
}

function bootstrapPdpNearStoreCards() {
  if (window.page !== 'product') return;
  if (hasRenderedPdpNearStoreCards()) return;

  const tryRender = () => {
    if (hasRenderedPdpNearStoreCards()) return true;
    const locationData = getLocationStoreData();
    if (!locationData || Object.keys(locationData).length === 0) return false;
    handleStoreData('123', '321');
    return true;
  };

  if (tryRender()) return;
  if (__pdpNearStoreBootstrapTimer) return;

  __pdpNearStoreBootstrapTimer = window.setInterval(() => {
    if (tryRender()) {
      window.clearInterval(__pdpNearStoreBootstrapTimer);
      __pdpNearStoreBootstrapTimer = 0;
    }
  }, 400);
}

// Function to update HTML with store data
function updateStoreHTML(storeList, data) {
  let storeHTMLSliced = '';
  let storeHTMLAll = '';

  // Group by city
  const cityGroupedStores = storeList.reduce((acc, store) => {
    const city = store.cityName || "Unknown";
    if (!acc[city]) acc[city] = [];
    acc[city].push(store);
    return acc;
  }, {});

  const locationData = getLocationStoreData();
  const nearStoreState = getEffectiveNearStoreAvailabilityState();
  const nearStoreCodeSet = nearStoreState.nearStoreCodeSet;
  let reservedProducts = readReservedProducts();
  let selectedSkuForReservation = selectedSKU || $("form [name='id'] option:selected").data("sku");

  const cityFilter = data?.city || locationData?.city || '';
  const normalizedCityFilter = normalizeStoreCityName(cityFilter);
  const scopedStoreCount = normalizedCityFilter
    ? storeList.filter((store) => normalizeStoreCityName(getStoreCityName(store)) === normalizedCityFilter).length
    : storeList.length;
  const shouldShowViewAll = scopedStoreCount > 8;
  const storeCity = shouldShowViewAll
    ? `<a href="#" class="ct-view-all-stores" data-city="${String(cityFilter || '').toLowerCase()}">View All</a>`
    : '';

  // 🟢 Step 1: reorder stores inside each city (available first, then unavailable)
  Object.keys(cityGroupedStores).forEach(city => {
    const stores = cityGroupedStores[city].filter(Boolean);
    cityGroupedStores[city] = [
      ...stores.filter(store => store && isInventoryAvailableForStore(nearStoreCodeSet, store, nearStoreState.hasRestriction)),  // available
      ...stores.filter(store => store && !isInventoryAvailableForStore(nearStoreCodeSet, store, nearStoreState.hasRestriction)) // unavailable
    ];
  });

  // 🟢 Step 2: flatten city groups while respecting city order, limit 8
  let finalStores = [];
  Object.keys(cityGroupedStores).forEach(city => {
    if (finalStores.length < 8) {
      const remainingSlots = 8 - finalStores.length;
      finalStores = [...finalStores, ...cityGroupedStores[city].slice(0, remainingSlots)];
      if (storeAvailableIcon && finalStores[0] && isInventoryAvailableForStore(nearStoreCodeSet, finalStores[0], nearStoreState.hasRestriction)) {
        storeAvailableIcon.style.display = 'flex';
      }
    }
  });

  // 🟢 Step 3: generate HTML for sliced stores
  finalStores.forEach(store => {
    const inventoryIsAvailable = isInventoryAvailableForStore(nearStoreCodeSet, store, nearStoreState.hasRestriction);
    const isReserved = hasReservedProductForStore(reservedProducts, store.id, selectedSkuForReservation);

    storeHTMLSliced += generateStoreHTMLSliced(store, data, inventoryIsAvailable, isReserved);
  });

  // Generate HTML for all stores (no slice); the appointment modal gets the Figma photo-hero card
  let storeHTMLAppt = '';
  storeList.forEach(store => {
    storeHTMLAll += generateStoreHTML(store);
    storeHTMLAppt += generateAppointmentStoreHTML(store);
  });

  allStoresPopupState = {
    storeList: Array.isArray(storeList) ? storeList : [],
    data: data || {},
    cityFilter: cityFilter,
    inventoryNearStoreCodes: Array.from(nearStoreCodeSet),
    inventoryRestrictionActive: nearStoreState.hasRestriction,
    reservedProducts: Array.isArray(reservedProducts) ? reservedProducts : [],
    selectedSKU: selectedSkuForReservation
  };

  // Inject into DOM
  const moreStoreElements = document.querySelectorAll(".ct_more_store");
  const appmtImage = document.querySelector('.appmt-image');

  if (moreStoreElements) {
    moreStoreElements.forEach((ele) => {
      if (ele.classList.contains('show-all-stores')) {
        ele.innerHTML = wrapStoreHTML(ele.closest('.appmt-modal') ? storeHTMLAppt : storeHTMLAll, "All Stores Near You", storeCity);
      } else {
        ele.innerHTML = wrapStoreHTML(storeHTMLSliced, "Stores Near You To Assist", storeCity);
      }
      ele.style.display = "block";
    });
  }

  
  if (appmtImage) {
    appmtImage.style.display = 'block';
  }
  document.dispatchEvent(new CustomEvent('storeLocator:storesRendered'));
}

function getAllStoresForPopup() {
  if (!allStoresPopupState || !Array.isArray(allStoresPopupState.storeList)) {
    return [];
  }

  const targetCity = normalizeStoreCityName(allStoresPopupState.cityFilter || allStoresPopupState.data?.city || '');
  let scopedStores = allStoresPopupState.storeList.filter(Boolean);

  if (targetCity) {
    const cityStores = scopedStores.filter((store) => normalizeStoreCityName(getStoreCityName(store)) === targetCity);
    if (cityStores.length > 0) scopedStores = cityStores;
  }

  const nearStoreCodeSet = new Set(
    (allStoresPopupState.inventoryNearStoreCodes || []).map((code) => normalizeStoreIdentifier(code))
  );
  const hasRestriction = !!allStoresPopupState.inventoryRestrictionActive;
  return [
    ...scopedStores.filter((store) => isInventoryAvailableForStore(nearStoreCodeSet, store, hasRestriction)),
    ...scopedStores.filter((store) => !isInventoryAvailableForStore(nearStoreCodeSet, store, hasRestriction))
  ];
}

function buildAllStoresPopupHTML() {
  const popupStores = getAllStoresForPopup();
  const nearStoreCodeSet = new Set(
    (allStoresPopupState?.inventoryNearStoreCodes || []).map((code) => normalizeStoreIdentifier(code))
  );
  const hasRestriction = !!allStoresPopupState?.inventoryRestrictionActive;
  const reservedProducts = Array.isArray(allStoresPopupState?.reservedProducts) ? allStoresPopupState.reservedProducts : [];
  const selectedSku = allStoresPopupState?.selectedSKU;

  return popupStores.map((store) => {
    const inventoryIsAvailable = isInventoryAvailableForStore(nearStoreCodeSet, store, hasRestriction);
    const isReserved = hasReservedProductForStore(reservedProducts, store.id, selectedSku);
    return generateStoreCardHTML(store, {
      cardClass: 'pdp-cards-stores',
      extraCardClass: 'ct-all-stores-popup__card',
      footerMode: 'inventory',
      inventoryIsAvailable,
      isReserved,
      isPopup: true
    });
  }).join('');
}

function getAllStoresPopupTitle() {
  return 'All Stores Near You';
}

function ensureAllStoresPopup() {
  let popup = document.getElementById(ALL_STORES_POPUP_ID);
  if (popup) return popup;

  popup = document.createElement('div');
  popup.id = ALL_STORES_POPUP_ID;
  popup.innerHTML = `
    <div class="ct-all-stores-popup__backdrop" data-popup-close></div>
    <div class="ct-all-stores-popup__sheet" role="dialog" aria-modal="true" aria-label="All stores">
      <div class="ct-all-stores-popup__head">
        <h3 class="ct-all-stores-popup__title"></h3>
        <button type="button" class="ct-all-stores-popup__close" data-popup-close aria-label="Close"></button>
      </div>
      <div class="ct-all-stores-popup__body">
        <div class="ct-all-stores-popup__search-wrap">
          <span class="ct-all-stores-popup__search-icon" aria-hidden="true"></span>
          <input
            type="text"
            class="ct-all-stores-popup__search"
            placeholder="Search by store name or area"
            aria-label="Search stores"
          >
          <button type="button" class="ct-all-stores-popup__search-clear" aria-label="Clear search" title="Clear search">&times;</button>
        </div>
        <div class="ct-all-stores-popup__list"></div>
        <div class="ct-all-stores-popup__empty ct-all-stores-popup__empty--search" style="display:none;">
          No stores match your search.
        </div>
      </div>
    </div>
  `;

  popup.addEventListener('click', (event) => {
    if (event.target.closest('[data-popup-close]')) {
      closeAllStoresPopup();
    }
  });

  const searchInput = popup.querySelector('.ct-all-stores-popup__search');
  const searchClearBtn = popup.querySelector('.ct-all-stores-popup__search-clear');
  searchInput?.addEventListener('input', function () {
    if (searchClearBtn) {
      searchClearBtn.classList.toggle('show', Boolean(this.value && this.value.trim()));
    }
    filterAllStoresPopup(this.value || '');
  });
  searchClearBtn?.addEventListener('click', function () {
    if (!searchInput) return;
    searchInput.value = '';
    this.classList.remove('show');
    filterAllStoresPopup('');
    searchInput.focus();
  });

  document.body.appendChild(popup);
  return popup;
}

function filterAllStoresPopup(query) {
  const popup = document.getElementById(ALL_STORES_POPUP_ID);
  if (!popup) return;

  const normalizedQuery = normalizeSearchText(query);
  const storeCards = popup.querySelectorAll('.ct-all-stores-popup__list .store-more-box');
  const emptySearchState = popup.querySelector('.ct-all-stores-popup__empty--search');
  let visibleCount = 0;

  storeCards.forEach((card) => {
    const haystack = normalizeSearchText(card.textContent || '');
    const isVisible = !normalizedQuery || haystack.includes(normalizedQuery);
    card.style.display = isVisible ? '' : 'none';
    if (isVisible) visibleCount += 1;
  });

  if (emptySearchState) {
    emptySearchState.style.display = visibleCount === 0 ? 'block' : 'none';
  }
}

function openAllStoresPopup() {
  if (!allStoresPopupState || !Array.isArray(allStoresPopupState.storeList) || allStoresPopupState.storeList.length === 0) return;

  const popup = ensureAllStoresPopup();
  const titleEl = popup.querySelector('.ct-all-stores-popup__title');
  const listEl = popup.querySelector('.ct-all-stores-popup__list');
  const searchInput = popup.querySelector('.ct-all-stores-popup__search');
  const listHtml = buildAllStoresPopupHTML();

  titleEl.textContent = getAllStoresPopupTitle();
  listEl.innerHTML = listHtml || '<div class="ct-all-stores-popup__empty">No stores found for this city.</div>';
  if (typeof updateStoreButtons === 'function') updateStoreButtons();   // reconcile labels after the rebuild
  // Fresh open starts at the top; .ct-all-stores-popup__body is the scroller and keeps its scrollTop across the
  // innerHTML swap (user 2026-10-23).
  const bodyEl = popup.querySelector('.ct-all-stores-popup__body');
  if (bodyEl) bodyEl.scrollTop = 0;
  if (searchInput) {
    searchInput.value = '';
    const searchClearBtn = popup.querySelector('.ct-all-stores-popup__search-clear');
    if (searchClearBtn) searchClearBtn.classList.remove('show');
    filterAllStoresPopup('');
  }

  // Trigger transition reliably, including first open right after DOM insertion.
  requestAnimationFrame(() => {
    popup.classList.add('show');
  });
  window.themeScrollLock && window.themeScrollLock.lock();
}

function closeAllStoresPopup() {
  const popup = document.getElementById(ALL_STORES_POPUP_ID);
  if (!popup) return;

  popup.classList.remove('show');
  window.themeScrollLock && window.themeScrollLock.unlock();
}



// Out-of-stock card inside the All Stores (reserve) popup → close the popup and open the appointment flow on step 2
// with this store preselected. Calls switchToLocationModal(card) directly (appointment-modal.js) rather than
// handleAppointmentAction(), because that one needs .appmt-store-box, which also drives the View Appointment
// relabel and is deliberately not on these cards (same reasoning as the inline card in pdp-delivery-stores.js).
function openAppointmentFromStoreCard(button) {
  const card = button.closest('.store-more-box');
  if (!card || typeof switchToLocationModal !== 'function') return;
  const storeName = card.querySelector('.store-more-name span')?.textContent.trim() || '';
  closeAllStoresPopup();
  // Relabelled to "View Appointment" by updateStoreButtons() after a booking (user 2026-10-22).
  if (/view appointment/i.test(button.textContent) && typeof switchToViewModal === 'function') {
    switchToViewModal(card);
    return;
  }
  switchToLocationModal(card);
  if (typeof clevertap !== 'undefined' && clevertap?.event?.push) {
    clevertap.event.push("book_appointment_modal", { "store_name": storeName });
  }
}

// Helper to generate individual store HTML
function generateStoreHTML(store) {
  return generateStoreCardHTML(store, { cardClass: 'appmt-store-box', footerMode: 'appointment' });
}

// Appointment modal (Figma Desktop > book-appointment, 2026-10-15): the same photo-hero card as the All
// Stores popup, with a Book Appointment CTA. Keeps .appmt-store-box + data-store-id + .store-more-name span
// + .store-more-text + .store_pro-link.ct_store_click for handleAppointmentAction / switchToViewModal /
// filterStores / updateStoreButtons, which scrape those.
function generateAppointmentStoreHTML(store) {
  return generateStoreCardHTML(store, {
    cardClass: 'appmt-store-box',
    extraCardClass: 'ct-all-stores-popup__card',
    footerMode: 'appointment',
    isPopup: true
  });
}

function generateStoreHTMLSliced(store, data, inventoryIsAvailable = false, isReserved = false) {
  return generateStoreCardHTML(store, {
    cardClass: 'pdp-cards-stores',
    footerMode: 'inventory',
    inventoryIsAvailable,
    isReserved
  });
}

function generateStoreCardHTML(store, options = {}) {
  const {
    cardClass = 'pdp-cards-stores',
    extraCardClass = '',
    footerMode = 'inventory',
    inventoryIsAvailable = false,
    isReserved = false,
    isPopup = false
  } = options;

  const openingTime = convertTo12HourFormat(store.openingTime);
  const closingTime = convertTo12HourFormat(store.closingTime);
  const openTime = openingTime.split(" ")[0];
  const timeCheck = updateStoreTime(openTime, store.closingTime, closingTime);
  const city = store.city || 'Unknown City';
  const inventoryMetaClass = isPopup ? 'ct-store-inventory-meta' : 'store-inventory-footer';
  const appmtLabel = hasAppointmentForStore(store.id) ? 'View Appointment' : 'Book Appointment';

  if (isPopup && (footerMode === 'inventory' || footerMode === 'appointment')) {
    const showInventory = footerMode === 'inventory' && window.page === 'product';
    const distanceLabel = getPopupStoreDistanceLabel(store);
    const hasPhoto = Boolean(store.image);
    // Figma export Desktop > reserve-flow (Home / Home-1) shows the green IN STOCK pill on
    // in-stock cards too, so both states render (an earlier cropped paste hid it).
    const stockPill = showInventory
      ? `<span class="ct-store-stock-pill ${inventoryIsAvailable ? '' : 'not-available'}">${inventoryIsAvailable ? 'In Stock' : 'Out of Stock'}</span>`
      : '';
    // Reserve popup, out of stock at this store (user ask 2026-10-16): offer Book Appointment instead of leaving only
    // the call icon — same jump-to-date-picker path as the inline out-of-stock card (pdp-delivery-stores.js).
    const reserveButton = footerMode === 'appointment'
      ? `<button type="button" class="book-appmt-button" onclick="handleAppointmentAction(this)">${appmtLabel}</button>`
      : (showInventory
        ? (inventoryIsAvailable
          ? (isReserved
            ? `<button type="button" class="reserve-product" onclick="stInventoryReservationOpen(this)">View Reservation</button>`
            : `<button type="button" class="reserve-product" onclick="handleInventoryAction(this)">Reserve Product</button>`)
          : `<button type="button" class="book-appmt-button" onclick="openAppointmentFromStoreCard(this)">${appmtLabel}</button>`)
        : '');

    return `
      <div class="store-more-box store-more-box-product ${cardClass} ${extraCardClass}" data-store-id="${store.id}">
        <div class="store-more-box-inner">
          <a class="store_pro-link ct_store_click" data-store="${store.name}" href="https://www.kushals.com/pages/store-details/${city}-${store.slug}">
            <div class="ct-store-hero${hasPhoto ? ' has-photo' : ''}">
              ${hasPhoto ? `<img class="ct-store-hero__img" src="${store.image}" alt="" loading="lazy">` : ''}
              <div class="store-more-box-head">
                <div class="store-more-name">
                  <span>${store.name}</span>
                </div>
                <div class="store-more-star">
                  <img src="${STORE_ICON_GOOGLE}" width="30" height="30">
                  <span>${store.rating}</span>
                </div>
              </div>
            </div>
            <div class="store-more-text">
              ${store.address}
            </div>
          </a>
          <div class="ct-store-meta-row">
            ${stockPill}
            ${timeCheck.replace('<span>Open</span>', '<span>Open Now</span>')}
            <div class="direction-main">
              <span><a class="ct_store_map" data-store="${store.name}" href="${store.direction}" target="_blank">${distanceLabel || 'Get Direction'}</a></span>
            </div>
          </div>
          <div class="call-dir-main ct-store-actions">
            <a href="tel:${store.phone}" class="ct_store_call" aria-label="Call Store" data-storedir="${store.name}" data-storecall="${store.phone}" data-store="${store.name}">
              <div class="call-main">
                <div class="call-icon">
                  <img src="${STORE_ICON_CALL}" alt="">
                </div>
              </div>
            </a>
            ${reserveButton}
          </div>
        </div>
      </div>
    `;
  }

  const footerHtml = footerMode === 'appointment'
    ? `
      <div class="store-more-footer">
        <button type="button" class="book-appmt-button" onclick="handleAppointmentAction(this)">${appmtLabel}</button>
      </div>
    `
    : `${window.page === 'product' ? `<div class="store-more-footer store-more-footer-inventory">
        <div class="store-inventory-footer ${!inventoryIsAvailable ? 'not-available' : ''}">
          <div class="${inventoryMetaClass} ${!inventoryIsAvailable ? 'not-available' : ''}">
            <img src="${productFullImage}" alt="product-mage">
            <span>${inventoryIsAvailable ? 'In Stock' : 'Out of Stock'}</span>
          </div>
          ${inventoryIsAvailable
            ? (isReserved
              ? `<button type="button" class="reserve-product" onclick="stInventoryReservationOpen(this)"> View Reservation</button>`
              : `<button type="button" class="reserve-product" onclick="handleInventoryAction(this)"> Reserve This Product </button>`)
            : ''}
        </div>
      </div>` : ''}`;

  return `
    <div class="store-more-box store-more-box-product ${cardClass} ${extraCardClass}" data-store-id="${store.id}">
      <div class="store-more-box-inner">
        <a class="store_pro-link ct_store_click" data-store="${store.name}" href="https://www.kushals.com/pages/store-details/${city}-${store.slug}">
          <div class="store-more-box-head">
            <div class="store-more-name">
              <span>${store.name}</span>
            </div>
            <div class="store-more-star">
              <img src="${STORE_ICON_GOOGLE}" width="30" height="30">
              <span>${store.rating}</span>
            </div>
          </div>
          <div class="store-more-text">
            ${store.address}
          </div>
        </a>
        <div class="call-dir-main">
          <a href="tel:${store.phone}" class="ct_store_call" data-storedir="${store.name}" data-storecall="${store.phone}" data-store="${store.name}">
            <div class="call-main">
              <div class="call-icon">
                <img src="${STORE_ICON_CALL}" alt="">
              </div>
              <span>Call Store</span>
            </div>
          </a>
          <div class="direction-main">
            <div class="direction-icon">
              <img src="${STORE_ICON_DIRECTION}" alt="">
            </div>
            <span><a class="ct_store_map" data-store="${store.name}" href="${store.direction}" target="_blank">Get Direction</a></span>
          </div>
          ${timeCheck}
        </div>
      </div>

      ${footerHtml}
    </div>
  `;
}


// Helper to wrap the stores with a header and storeCity
function wrapStoreHTML(storeHTML, heading, storeCity) {
    return `
        <div class="store-more-head">
            <span>${heading}</span>
            <div class="store-more-all ct_all_store">${storeCity}</div>

        </div>
        <div class="store-more-content near-stores">${storeHTML}</div>`;
}

// Function to convert time to 12-hour format
function convertTo12HourFormat(time) {
    let [hours, minutes] = time.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert hour to 12-hour format
    return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
}

// Function to check store open/close time
function updateStoreTime(openTime, closeTime, storeCloseTime) {
    const currentTime = new Date();
    const openingDate = new Date(currentTime);
    const closingDate = new Date(currentTime);

    const [openHours, openMinutes] = openTime.split(':').map(Number);
    const [closeHours, closeMinutes] = closeTime.split(':').map(Number);

    openingDate.setHours(openHours, openMinutes, 0);
    closingDate.setHours(closeHours, closeMinutes, 0);

    if (closingDate <= openingDate) {
        closingDate.setDate(closingDate.getDate() + 1);
    }

    if (currentTime >= openingDate && currentTime < closingDate) {
        return `<div class="open-close-store"> <div class="dot"></div> <span>Open</span> </div>`;
    } else {
        return `<div class="open-close-store close_store"> <div class="dot"></div> <span>Closed</span> </div>`;
    }
}

jQuery(document).ready(function () {
    if (window.page === 'product') {
        refreshSelectedSkuFromDom();
        refreshPdpStoreAvailabilityUI();
        bootstrapPdpNearStoreCards();

        // Keep badge in sync with selected variant.
        $(document).on('change', "form [name='id'], .product-form [name='id']", function () {
            refreshSelectedSkuFromDom();
            schedulePdpStoreAvailabilityRefresh();
        });
        $(window).on('cc-variant-updated', function (event, args) {
            if (args && args.variant && args.variant.sku != null) selectedSKU = String(args.variant.sku || '').trim();
            else refreshSelectedSkuFromDom();
            schedulePdpStoreAvailabilityRefresh();
        });

        // Re-evaluate when location gets updated in localStorage.
        window.addEventListener('storage', function (event) {
            if (!event || !event.key) return;
            if (event.key === 'location_store' || event.key === 'current_location') {
                schedulePdpStoreAvailabilityRefresh();
                bootstrapPdpNearStoreCards();
            }
        });

        if (!window.__storeLocatorLocationStoragePatchApplied && window.localStorage) {
            window.__storeLocatorLocationStoragePatchApplied = true;
            const originalSetItem = window.localStorage.setItem;
            const originalRemoveItem = window.localStorage.removeItem;

            try {
                window.localStorage.setItem = function (key, value) {
                    const result = originalSetItem.apply(this, arguments);
                    if (key === 'location_store' || key === 'current_location') {
                        schedulePdpStoreAvailabilityRefresh();
                        bootstrapPdpNearStoreCards();
                    }
                    return result;
                };
            } catch (e) {}

            try {
                window.localStorage.removeItem = function (key) {
                    const result = originalRemoveItem.apply(this, arguments);
                    if (key === 'location_store' || key === 'current_location') {
                        schedulePdpStoreAvailabilityRefresh();
                    }
                    return result;
                };
            } catch (e) {}
        }
    }

    if(window.page === 'product') {
        $(window).on("scroll.moreStore", function () {
            var scrollTop = $(window).scrollTop(); // Current scroll position
            var windowHeight = $(window).height(); // Viewport height
            var section = $(".ct_more_store "); // Target section
    
            if (section.length === 0) {
                return; // Exit if the section does not exist
            }
    
            var offset = section.offset().top; // Distance from top of the document to the section
            // Check if the section is in view
            if (scrollTop + windowHeight >= offset) {
                handleStoreData("123", "321"); // Call your function
                $(window).off("scroll.moreStore"); // Remove scroll listener to prevent further calls
            }
        });
    } else {
        const interval = setInterval(() => {
            if (localStorage.getItem('location_store')) {
                handleStoreData("123", "321");
                clearInterval(interval);
            }
        }, 1000);
    }
    

    if (localStorage.getItem('pin') != undefined) {
        var pin_get = localStorage.getItem('pin');
        jQuery(".clickpost-edd__drop_pincode-input").val(pin_get);
        pin_checker(pin_get);
    }

    jQuery(document).on("input", ".clickpost-edd__form .clickpost-edd__drop_pincode-input", function () {
        const input_pin_number = jQuery(".clickpost-edd__drop_pincode-input").val();
        if (input_pin_number.length === 6) {
            pin_check(input_pin_number);
            pin_checker(input_pin_number);
        } else if (input_pin_number == "") {
            jQuery(".ct_msg_show").hide();
        }
    });
});

function pin_checker(pin_number) {
    if (pin_number.length === 6) {
        jQuery(".clickpost-edd__drop_pincode-input").val(pin_number);
        jQuery(".clickpost-edd__form .clickpost-edd__submit-button").trigger("click");
    }
}

function count_date(c_date_no) {
    const d = new Date();
    d.setDate(d.getDate() + c_date_no);

    const date = d.getDate();
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const month = monthNames[d.getMonth()];

    const weekdayNames = [
        "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ];
    const weekday = weekdayNames[d.getDay()];

    return { date, week: weekday, month };
}

jQuery(document).on("click",".ct_store_call",function(){
    var store_name=jQuery(this).attr("data-store");
    clevertap.event.push("Call_Store", {
        "CallStore_Name":store_name
    });
});

$(document).on("click", ".ct_store_click", function () {
    const storeName = $(this).data("store");
    clevertap.event.push("Store_Name", { "Store Name": storeName });
});

$(document).on("click", ".ct_store_map", function () {
    const storeName = $(this).data("store");
    clevertap.event.push("Store_Name_Direction", { "Store Name direction": storeName });
});

$(document).on("click", ".ct_all_store a", function () {
    clevertap.event.push("MoreStores");
});

$(document).on("click", ".ct-view-all-stores", function (event) {
    event.preventDefault();
    openAllStoresPopup();
});

$(document).on("click", `#${ALL_STORES_POPUP_ID} .reserve-product`, function () {
    closeAllStoresPopup();
});

document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        closeAllStoresPopup();
    }
});


    const stInventoryOverlay = document.querySelector('.stInventory-overlay');
    const stInventoryModal = document.querySelector('.stInventory-modal');
    const stInventoryMiddle = document.querySelector('.stInventory-middle');
    const stInventorySuccess = document.querySelector('.stInventory-modal-success');
    const selectedStoreContent = document.querySelector('.selected-store-content');
    let storeId = '';

    let reservedProducts = readReservedProducts();

    const handleInventoryAction = (button) => {
        const buttonParent = button.closest('.store-more-box');
        const storeName = buttonParent.querySelector('.store-more-name span')?.textContent.trim() || '';
        const storeDescription = buttonParent.querySelector('.store-more-text')?.textContent.trim() || '';
        const storeRating = buttonParent.querySelector('.store-more-star span')?.textContent.trim() || '';
        const storeCall = buttonParent.querySelector('.call-dir-main a')?.href.trim() || '';
        const storeDirection = buttonParent.querySelector('.ct_store_map')?.href.trim() || '';
        // Photo: popup card = .ct-store-hero__img; inline PDP card = .pdp-ds-photo img (added by
        // pdp-delivery-stores.js decorateStores). Distance: the inline card keeps its "Get Direction"
        // .ct_store_map AND gets a .pdp-ds-km.ct_store_map, so prefer the km one.
        const storePhoto = buttonParent.querySelector('.ct-store-hero__img, .pdp-ds-photo img')?.getAttribute('src') || '';
        const storeDistanceText = (buttonParent.querySelector('.pdp-ds-km') || buttonParent.querySelector('.ct_store_map'))?.textContent.trim() || '';
        storeId = buttonParent.getAttribute('data-store-id');


        const callStoreDiv = document.querySelector('.selected-store-call');
        const storeDirectionDiv = document.querySelector('.selected-ct_store_map');

        callStoreDiv.setAttribute('href', storeCall);
        callStoreDiv.setAttribute('data-store', storeName);
        storeDirectionDiv.setAttribute('href', storeDirection);
        storeDirectionDiv.setAttribute('data-store', storeName);
        stInventorySetDirectionLabel(storeDistanceText, storeDirection);

        // Store photo thumbnail (Figma Selected Store card). Only the All Stores popup card
        // carries .ct-store-hero__img; the inline PDP card has none, so the thumb hides there.
        const thumb = stInventoryModal.querySelector('.stInventory-store-thumb__img');
        if (thumb) {
            if (storePhoto) { thumb.setAttribute('src', storePhoto); thumb.hidden = false; }
            else { thumb.removeAttribute('src'); thumb.hidden = true; }
        }

        // Select all visible modals (in case there are multiple)
        const modals = document.querySelectorAll('.stInventory-modal, .stInventory-middle, .stInventory-modal-success');
        modals.forEach(modal => {
            // :not(.stInventory-stock-pill) — .store-more-name holds both the name span AND the
            // In Stock pill span; an unscoped selector here overwrote the pill's text with the store
            // name too (fixed 2026-10-15).
            const stInventoryStoreName = modal.querySelectorAll('.stInventory-store-list .store-more-name span:not(.stInventory-stock-pill)');
            const stInventoryStoreDescription = modal.querySelectorAll('.stInventory-store-list .store-more-text');
            const stInventoryStoreRating = modal.querySelectorAll('.stInventory-store-list .store-more-star span');

            stInventoryStoreName.forEach((el) => el.textContent = storeName);
            stInventoryStoreDescription.forEach((el) => el.textContent = storeDescription);
            stInventoryStoreRating.forEach((el) => el.textContent = storeRating);
        });

        if (!stInventoryOverlay.classList.contains('show')) {
            window.themeScrollLock && window.themeScrollLock.lock();
            stInventoryOverlay.classList.add('show');
        }
        stInventoryModal.classList.add('show');
        stInventoryRefreshReady();

        clevertap.event.push("Reserve_Btn_clicked", {
            "ReserveProduct_StoreName": storeName,
            "ReserveProduct_SKU": selectedSKU,
            "ReserveProduct_ProductName": pdpProductTitle
        });
    }

    // The two-step flow (.stInventory-modal -> .stInventory-middle) was merged into one screen
    // (Figma Desktop > reserve-flow, 2026-10-15). Kept as a no-op so any stale inline onclick
    // can't throw.
    const stInventoryMiddleAction = () => {};

    // "DIRECTIONS · 1.2 KM" on the success footer: the card's .ct_store_map text is either
    // "x km away" (popup, geolocated; km only since 2026-10-16) or "Get Direction" (inline card).
    const stInventorySetDirectionLabel = (distanceText, directionHref) => {
        const m = String(distanceText || '').match(/^([\d.]+\s*(?:km|m))\s+away$/i);
        const label = document.querySelector('.stInventory-modal-success .selected-store-direction__label');
        if (label) label.textContent = m ? `Directions · ${m[1]}` : 'Directions';
        // Green "x km away" link on the success store card (Figma Home-9/10); hidden when no distance.
        const km = document.querySelector('.stInventory-modal-success .stInventory-success-km');
        if (km) {
            if (m) { km.textContent = `${m[1]} away`; km.setAttribute('href', directionHref || '#'); km.hidden = false; }
            else { km.textContent = ''; km.hidden = true; }
        }
    };

    // CONFIRM is muted until name, a valid 10-digit mobile and an email with "@" are all in
    // (Figma Home-4..7). Click-time validation below still shakes the bad field.
    const stInventoryRefreshReady = () => {
        const btn = stInventoryModal.querySelector('.stInventory-footer .next-stInventory');
        if (!btn) return;
        const name = stInventoryModal.querySelector('.selected-store-content .appmt-input-name')?.value.trim() || '';
        const num = stInventoryModal.querySelector('.selected-store-content .appmt-input-num')?.value.trim() || '';
        const email = stInventoryModal.querySelector('.selected-store-content .appmt-input-email')?.value.trim() || '';
        const ready = name.length > 0 && /^[6-9]\d{9}$/.test(num) && email.includes('@');
        btn.classList.toggle('is-ready', ready);
    };

    const stInventorySuccessOpen = async () => {
        // check all the input fields for values
        const nameInput = stInventoryModal.querySelector('.selected-store-content .appmt-input-name');
        const numberInput = stInventoryModal.querySelector('.selected-store-content .appmt-input-num');
        const phoneNumberContainer = stInventoryModal.querySelector('.selected-store-content .appmt-number-container');
        const isValidPhoneNumber = (val) =>
          /^[6-9]\d{9}$/.test(String(val || '').trim()) &&      // starts 6–9
          !/^(\d)\1{9}$/.test(val) &&                           // not 0000000000, 1111111111, etc.
          !['1234567890','0123456789','9876543210','0987654321'].includes(val);
        
        let validNumber = isValidPhoneNumber(numberInput.value.trim());
        const emailInput = stInventoryModal.querySelector('.selected-store-content .appmt-input-email');
        const emailValue = emailInput.value.trim();
        const isValidEmail = emailValue.includes('@');
        if (!nameInput.value || !numberInput.value || !emailInput.value || !isValidEmail || !validNumber || numberInput.value.length < 10) {
            if (!nameInput.value) {
                nameInput.classList.add('appmt-input-warning', 'shake');
                setTimeout(() => nameInput.classList.remove('shake'), 500);
            }

            if(!emailInput.value) {
                emailInput.classList.add('appmt-input-warning', 'shake');
                setTimeout(() => emailInput.classList.remove('shake'), 500);
            }

            if(!isValidEmail) {
                emailInput.classList.add('appmt-input-warning', 'shake');
                setTimeout(() => emailInput.classList.remove('shake'), 500);
            }

            if (!numberInput.value || numberInput.length < 10 || !validNumber) {
                numberInput.classList.add('appmt-input-warning');
                phoneNumberContainer.classList.add('shake');
                setTimeout(() => phoneNumberContainer.classList.remove('shake'), 500);
            }

            if (navigator.vibrate) {
                navigator.vibrate(100);
            }
            return;
        }

        const confirmBtn = stInventoryModal.querySelector('.stInventory-footer .next-stInventory');
        confirmBtn.classList.add('is-loading');
        confirmBtn.disabled = true;
        const apiResult = await callReserveStoreAPI(nameInput.value, numberInput.value, emailInput.value);
        confirmBtn.classList.remove('is-loading');
        confirmBtn.disabled = false;
        if (apiResult) {
            stInventoryModal.classList.remove('show');
            stInventoryModal.classList.add('hide');
            stInventorySuccess.classList.add('show');
            stInventorySuccess.querySelector('.stInventory-success-container').classList.remove('is-hidden');
        }
    }

    const stInventoryReservationOpen = (button) => {
        const buttonParent = button.closest('.store-more-box');
        const storeName = buttonParent.querySelector('.store-more-name span')?.textContent.trim() || '';
        const storeDescription = buttonParent.querySelector('.store-more-text')?.textContent.trim() || '';
        const storeCall = buttonParent.querySelector('.call-dir-main a')?.href.trim() || '';
        const storeDirection = buttonParent.querySelector('.ct_store_map')?.href.trim() || '';
        storeId = buttonParent.getAttribute('data-store-id');
        document.querySelector('.stInventory-modal-success .selected-store-call').setAttribute('href', storeCall);
        document.querySelector('.stInventory-modal-success .selected-ct_store_map').setAttribute('href', storeDirection);
        stInventorySetDirectionLabel((buttonParent.querySelector('.pdp-ds-km') || buttonParent.querySelector('.ct_store_map'))?.textContent.trim() || '', storeDirection);
        const modals = document.querySelector('.stInventory-modal-success');
        modals.querySelector('.store-more-name span').textContent = storeName;
        modals.querySelector('.store-more-text').textContent = storeDescription;
        window.themeScrollLock && window.themeScrollLock.lock();
        stInventoryOverlay.classList.add('show');
        stInventorySuccess.classList.add('show');
        stInventorySuccess.querySelector('.stInventory-success-container').classList.add('is-hidden');

        let storedDetails = readReservedProducts();

        storedDetails.forEach((product) => {
            if (Number(product.storeId) === Number(storeId)) {
                stInventorySuccess.querySelector('.stInventory-prd-heading').textContent = `Booking ID: ${product.bookingId}`;
            }
        });
    }
    
    async function callReserveStoreAPI(customerName, phoneNumber, emailId) {
        let twoDaysFromNow = new Date();
        twoDaysFromNow.setDate(twoDaysFromNow.getDate() + 2);
        // Format date as YYYY-MM-DD
        const yyyy = twoDaysFromNow.getFullYear();
        const mm = String(twoDaysFromNow.getMonth() + 1).padStart(2, '0');
        const dd = String(twoDaysFromNow.getDate()).padStart(2, '0');
        const formattedDate = `${yyyy}-${mm}-${dd}`;

        const url = `${window.apiUrl}/store-visit`;
        const data = {
            customerName: customerName,
            phoneNumber: phoneNumber,
            emailId: emailId,
            productName: pdpProductTitle,
            sku: selectedSKU,
            visitDate: formattedDate,
            purpose: `Reserve Product: ${pdpProductTitle} SKU:${selectedSKU} `,
            storeId: storeId,
            sourceType: "Product_Reservation"
        };

        try {
            const options = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            };

            const response = await fetch(url, options);
            const responseData = await response.json();

            if (!response.ok) {
                showError('Please try again later');
                console.error(`API error: ${responseData.message || response.statusText}`);
                kStoreTrack('store_inventory_reserve_failed', {
                    store_id: storeId,
                    store_name: document.querySelector('.stInventory-modal-success .store-more-name span')?.textContent.trim() || '',
                    failure_reason: 'api_error',
                    http_status: response.status,
                    error_message: responseData && responseData.message ? String(responseData.message) : ''
                });
                return false;
            } else {
                let stInventoryId = document.querySelector('.stInventory-prd-heading');
                let selectedSKU = $("form [name='id'] option:selected").data("sku");

                reservedProducts.push({
                    customerName: customerName,
                    phoneNumber: phoneNumber,
                    customerEmail: emailId,
                    storeId: storeId,
                    sku: selectedSKU,
                    bookingId: responseData.id
                });

                syncReservedProductState(storeId, responseData.id, selectedSKU, reservedProducts);

                stInventoryId.innerHTML = `Booking ID: ${responseData.id}`;

                clevertap.profile.push({
                  "Site": {
                    "Name": customerName,
                    "Phone": `+91${phoneNumber}`,
                    "Email": emailId,
                // optional fields. controls whether the user will be sent email, push etc.
                    "MSG-email": false,
                    "MSG-push": true,
                    "MSG-sms": true,
                    "MSG-whatsapp": true,
                  }
                });

                let storeName = document.querySelector('.stInventory-modal-success');
                storeName = storeName.querySelector('.store-more-name span')?.textContent.trim() || '';
                clevertap.event.push("Reserve_Submit_clicked", {
                    "ReserveSubmit_StoreName": storeName,
                    "ReserveSubmit_SKU": selectedSKU,
                    "ReserveSubmit_ProductName": pdpProductTitle,
                    "ReserveSubmit_StoreID": storeId,
                    "ReserveSubmit_Date": formattedDate,
                    "ReserveStoreDirection": document.querySelector('.selected-ct_store_map').getAttribute('href'),
                    "ReserveStoreCall": document.querySelector('.selected-store-call').getAttribute('href'),
                    "ReserveSubmit_CustomerEmail": emailId,
                    "ReserveSubmit_CustomerPhone": phoneNumber,
                    "ReserveSubmit_BookingID": responseData.id,
                    "ReserveSubmit_CustomerName": customerName
                });
                kStoreTrack('store_inventory_reserve_confirmed', {
                    store_id: storeId,
                    store_name: storeName,
                    booking_id: responseData.id,
                    visit_date: formattedDate,
                    sku: String(selectedSKU == null ? '' : selectedSKU) // jQuery .data() coerces "412814" to a number
                });
                return true;
            }
        } catch (error) {
            showError('Please try again later');
            console.error('Error hitting the API:', error);
            kStoreTrack('store_inventory_reserve_failed', {
                store_id: storeId,
                store_name: document.querySelector('.stInventory-modal-success .store-more-name span')?.textContent.trim() || '',
                failure_reason: 'network_or_parse_error',
                error_message: error && error.message ? String(error.message) : ''
            });
            return false;
        }
    }

    function stValidateName() {
        const customerName = stInventoryModal.querySelector('.selected-store-content .appmt-input-name');
        if (customerName.classList.contains('appmt-input-warning')) {
            customerName.classList.remove('appmt-input-warning');
        }
        stInventoryRefreshReady();
    }

    function stValidateEmail() {
        const customerEmail = stInventoryModal.querySelector('.selected-store-content .appmt-input-email');
        const emailValue = customerEmail.value.trim();

        if (customerEmail.classList.contains('appmt-input-warning')) {
            customerEmail.classList.remove('appmt-input-warning');
        }

        const isValidEmail = emailValue.includes('@');

        if (isValidEmail) {
            customerEmail.classList.remove('appmt-input-warning');
        }
        stInventoryRefreshReady();
    }

    function stValidateNumber(inputElement) {
        let value = inputElement.value.replace(/\D/g, ''); // Remove any non-numeric characters
        if (value.length > 10) {
            value = value.slice(0, 10); // Restrict to 10 digits
        }
        inputElement.value = value; 

        const customerNum = stInventoryModal.querySelector('.selected-store-content .appmt-input-num');
        if (value.length === 10) {
            if (customerNum.classList.contains('appmt-input-warning')) {
                customerNum.classList.remove('appmt-input-warning');
            }
        }
        stInventoryRefreshReady();
    }


    const stInventoryClose = () => {
        window.themeScrollLock && window.themeScrollLock.unlock();
        stInventoryOverlay.classList.remove('show');
        stInventoryModal.classList.remove('show');
        stInventoryModal.classList.remove('hide');
        if (stInventoryMiddle) { stInventoryMiddle.classList.remove('hide'); stInventoryMiddle.classList.remove('show'); }
        stInventorySuccess.classList.remove('show');
    }

    // Keyboard overlap (user 2026-10-16): the sheet is position:absolute; bottom:0 inside a fixed overlay and the
    // on-screen keyboard does not shrink the layout viewport (iOS always, Android Chrome by default), so the sticky
    // CONFIRM footer sat under the keyboard while editing name / mobile / email. bindViewportKeyboardAdjust
    // (custom.js) lifts the sheet by the covered height from visualViewport and clears the inline styles when the
    // keyboard closes. Empty reset values = remove the inline style, so the 92dvh CSS cap comes back untouched.
    if (stInventoryModal && window.KViewportKeyboardAdjust) {
        window.KViewportKeyboardAdjust.bind({
            target: stInventoryModal,
            focusSelectors: '.stInventory-modal input',
            closeSelectors: '.stInventory-close, .stInventory-modal-success .custom-close-modal',
            focusAnchor: '.stInventory-p',
            footerSelector: '.stInventory-footer',
            resetBottom: '',
            resetMaxHeight: ''
        });
    }
